import { React, DateFNS } from '@common/3rd';
import { DeskPage, DeskPageBody, DeskPanelBody, DeskPanelBodyCell } from '@desk-component';
import { PageComponents, DeskPageBodyComponents, ButtonType } from '@my-types';
import { Utils, Storage, Apis, Envs, Ajax, PATH } from '@common';
import { orderType } from '../const';
import { DeskButton, DeskPanel, DeskImage } from '@desk-component';
import { StyledComponents } from '@styles';
import Dialog from '@dialog';
import { useState, useEffect } from 'react';
import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { VendorCade } from '../product/product';
import Alert from '@alert';
import Countdown from '@component/countdown';

SwiperCore.use([Autoplay, Navigation, Pagination])

class EnterpriseExclusive extends DeskPage<any, any, PageComponents & DeskPageBodyComponents> {
	constructor(props: any) {
		super(props);
		this.state = {
			useInHome: props.useInHome,
			onlyEnterprise: props.onlyEnterprise,
			bannerList: [],
			coverage: '',
			coverageType: [],
			orderType: orderType,
			order: '',
			priceOrder: '',
			vendorTypeList: [],
			targetGroup:'',
			productList: [],
			vendorList: [],
			countdown: {
				targetDate: undefined
			}
		}
	}
	async queryProductList(options?: { tagName?: string, targetGroup?: string, vendorList?: any[] }) {
		const { tagName = this.state.coverage, targetGroup = this.state.targetGroup, vendorList = this.state.vendorList } = options || {};
		try {
			let path = Apis.QUERY_PRODUCT_LIST + '?pageSize=999';
			let queryParams: { [propName: string]: any } = {
				tagName: tagName || '',
				keyword: '',
				targetGroup: !Utils.isBlank(targetGroup) ? targetGroup : null,
				vendorList
			};
			if (!Ajax.isAuthorized()) {
				queryParams.tenantCode = this.tenantCode;
			}
			if (this.state.priceOrder) {
				queryParams.orderByPrice = this.state.priceOrder; // 'DESC' 'ASC'
			}
			let organInSession = Storage.Last.session().get('organ');
			if (organInSession?.organCode) {
				queryParams.organCode = organInSession.organCode;
			}
			let res = await this.getHelpers().getAjax().post(path, queryParams, { loading: false });
			let res2 = await this.getHelpers().getAjax().get(Apis.AGREE_PRODUCT_CHANNEL_LIST_ORGAN_LIST_ORGAN_AVAILABLE, Object.assign({
				tenantCode: this.tenantCode,
				channelCode: organInSession?.organCode,
				pageSize: '9999'
			}), {
				loading: false,
				ignoreAuth: true
			});
			console.log('enterprise product list res', res);
			if (res?.body?.body?.items) {
				if (Utils.isBlank(tagName) && Utils.isBlank(targetGroup) && Utils.toArray(vendorList).length === 0) { // 查询全部时，更新产品tag列表
					let coverageType = this.getProductTags(res.body.body.items);
					let vendorTypeList = this.getVendorNameTags(res.body.body.items);
					this.setState({
						coverageType: coverageType,
						vendorTypeList
					});
				}
				this.setState({
					productList: (res.body.body.items as any[]).map(item => {
						item.showOverall = false;
						item.qrcode = '';
						return item;
					})
				}, () => {
					this.props.onGetProductList && this.props.onGetProductList(this.state.productList);
				});
			}
			if (res2?.body?.body?.items) {
				this.state.countdown.suffix && this.handleCountdown(res2.body.body.items);
			}
		} catch (e) {
			console.log('query product list error', e);
		}
	}
	async componentDidMount() {
		await super.componentDidMount();
		let organInSession = Storage.Last.session().get('organ');
		const account = Envs.findAccount();
		// Ajax.isAuthorized() && 
		if (organInSession?.organCode) {
			this.queryProductList();
			let params: { [propName: string]: any } = {
				tenantCode: account.tenantCode || this.tenantCode,
				configType: "SALES_CONFIG", // 不在使用数字"3",使用英文字母组合
				organCode: organInSession.organCode,
				status: 1
			};
			let organRes = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params, { loading: false });
			// console.log(organRes);
			if (organRes?.body?.body && organRes.body.body.length) {
				let configList: { [propName: string]: any }[] = organRes.body.body;
				let entObj = Utils.getConfigFromRes(configList, { detailConfigType: '5', isOgran: true });
				if (entObj?.list && entObj.list.length) {
					let obj = entObj.list[0];
					this.setState({
						bannerList: obj.banners,
						countdown: {
							...this.state.countdown,
							suffix: obj.countdownScript
						}
					});
				}
			}
		}
	}
	handleCountdown(list: any[]) {
		let show = list.every(item => item.expiryDate && item.expiryDate === list[0].expiryDate); // 所有失效日期相同，显示倒计时
		show = show && (+new Date() < +new Date(list[0].expiryDate));
		if (list.length && show) {
			this.setState({
				countdown: {
					...this.state.countdown,
					targetDate: list[0].expiryDate
				}
			});
		}
	}
	formatTime = (targetDate: Date) => {
		let now = new Date();
		const days = DateFNS.diffInDays(targetDate, now);
		now = DateFNS.addDay(now, days);
		const hours = DateFNS.diffInHours(targetDate, now);
		now = DateFNS.addHour(now, hours);
		const minuts = DateFNS.diffInMinutes(targetDate, now);
		now = DateFNS.addMinute(now, minuts);
		const seconds = DateFNS.diffInSeconds(targetDate, now);
		return {
			stop: +now >= +new Date(targetDate),
			text: `${days}天${hours}时${minuts}分${seconds}秒`
		};
	}
	closeAllMouseOver() {
		if (this.state.productList?.length) {
			(this.state.productList as any[]).forEach(i => {
				this.handleMouseLeave(i, 'productList');
			})
		}
	}
	closeCountdown() {
		this.setState({
			countdown: {
				targetDate: undefined
			}
		})
	}
	renderPageBody() {
		const C = this.getComponents();
		const CountdownText = (props: { targetDate: Date, suffixText?: string | undefined, stopCallback?: any }) => {
			let current = this.formatTime(props.targetDate);
			const [text, setText] = useState<String>(current.text);
			let timer = setInterval(() => {
				let current = this.formatTime(props.targetDate);
				if (current.stop) {
					timer && clearInterval(timer);
					props.stopCallback && props.stopCallback();
				} else {
					setText(current.text);
				}
			}, 1000);
			useEffect(() => {
				return () => {
					timer && clearInterval(timer);
				}
			})
			return <>{props.suffixText} {text}</>
		};
		return <DeskPageBody where="企业专属" tenantCode={this.tenantCode} vendor={this.props?.vendor}>
			{this.state.onlyEnterprise === false ? null : <>
				{this.state.bannerList.length ?
					/* @ts-ignore */
					<Swiper modules={[Autoplay, Navigation, Pagination]} observer={true} observeParents={true}
						autoplay={{ delay: 3000 }} loop={true} navigation pagination={{ clickable: true }} className="top-swiper"
					>
						{(this.state.bannerList as any[]).map((item, index) => {
							return <SwiperSlide key={`swiper_${index}`}>
								<div onClick={async () => {
									if (item.category === '1') {
										await this.handleMouseOver(item, 'bannerList');
										// let dialogRef = Dialog.show(item?.productInfo?.advertisementName, <DeskPanel css={() => `align-items: center;img {width: 200px;margin-top: 10px;}`}>
										// 	<img src={item.qrcode} alt="" />
										// </DeskPanel>,
										// <DeskButton
										// 	type={ButtonType.PRIMARY}
										// 	label="关闭" css={() => `margin-top: 20px;width: 150px;`}
										// 	onClick={() => {
										// 		Dialog.hide(dialogRef);
										// 	}}
										// />,
										// {
										// 	boxCSS: {width: '400px', top: '10vh', padding: '40px'},
										// 	headerCSS: () => `[data-widget="dialog-header-title"]{font-size: 14px;}
										// 	& > div:nth-child(2) {position: absolute;right: 10px;top:10px;font-size:3em;}`
										// });
									} else if ((item.category === '2' || item.category === '3') && item.thirdUrl && Utils.isValidHttpUrl(item.thirdUrl)) {
										if(item.thirdFlag === true ){
											Alert.ask('即将跳转外部链接').then(() => {
												window.open(item.thirdUrl, '_blank');
											});
										}else{
											window.open(item.thirdUrl, '_blank');
										}
									}
								}}>
									<DeskImage src={item.image} alt="" css={() => `width: 100%;`} />
								</div>
							</SwiperSlide>
						})}
					</Swiper> : null}</>}
			{!this.state.onlyEnterprise && this.state.useInHome ? <C.ContentWrapper css={() => `margin-top: 20px!important;`}>
				{this.props.productListInConfig?.length ? <div className="title">
					<span>
						企业精选&nbsp;&nbsp;
						{this.state.countdown.targetDate ?
							<span style={{
								color: '#EE750B',
								fontWeight: 400,
								fontSize: '18px'
							}}><CountdownText suffixText={this.state.countdown.suffix} targetDate={this.state.countdown.targetDate} stopCallback={this.closeCountdown.bind(this)} /></span> : null}
					</span>
					{Envs.findAccount().hasOwnProperty('showMall') && !Envs.findAccount().showMall ? '' :
						<a className="link" onClick={() => {
							this.getHelpers().getRouter().pushRedirect(PATH.DESK2_ENTERPRISE_EXCLUSIVE);
						}}>全部&gt;</a>}
				</div> : null}
			</C.ContentWrapper> : <>
				{this.state.countdown.targetDate ? <C.ContentWrapper css={() => `
				font-size:16px;color:#FF8216;background:#fef8ec;justify-content:center;;&:after{display:none;}`}>
					<CountdownText suffixText={this.state.countdown.suffix} targetDate={this.state.countdown.targetDate} stopCallback={this.closeCountdown.bind(this)} />
				</C.ContentWrapper> : null}
			</>}
			{this.state.onlyEnterprise === false ? null : <>
				<C.ContentWrapper css={() => `margin-top: 20px!important;`}>
					<C.Classification>
						<div className="not-button">按险种:&nbsp;&nbsp;</div>
						{(this.state.coverageType as any[]).map((item, index) => <div key={`coverage_${index}`}
							className={this.state.coverage === item.code ? 'active' : ''}
							onClick={() => {
								this.setState({
									coverage: item.code
								});
								this.queryProductList({ tagName: item.code });
							}}
						>
							<div>
								{item.name}
							</div>
						</div>)}
					</C.Classification>
					<C.TargetGroupClassification>
						<div>
							<div>为谁买:&nbsp;&nbsp;</div>
							{([{ code: '', name: '不限' },{ code: '1', name: '成人' }, { code: '2', name: '老人' }, { code: '3', name: '少儿' }, { code: '99', name: '其他' }] as any[]).map((item, index) => <div key={`targetGroup_${index}`}
								className={this.state.targetGroup === item.code ? 'active' : ''}
								onClick={() => {
									this.setState({
										targetGroup: item.code
									});
									this.queryProductList({ targetGroup: item.code });
								}}
							>
								<div>{item.name}</div>
							</div>)}
						</div>
						<VendorCade vendorList={this.state.vendorTypeList} query={(codes: []) => {
							this.setState({
								vendorList: codes
							}, () => {
								this.queryProductList({ vendorList: codes })
							});
						}} />
					</C.TargetGroupClassification>
				</C.ContentWrapper>
				{ Utils.toArray(this.state.productList).length != 0 ?
				<C.ContentWrapper css={() => `margin-top: 20px!important;`}>
					<div></div>
					{(this.state.productList as any[]).map((item, index) => {
						return <C.Product key={`ent_${index}`} onClick={() => {
							if (item.qrcode) {
								this.handleMouseLeave(item, 'productList');
							} else {
								this.closeAllMouseOver();
								this.handleMouseOver(item, 'productList', true);
							}
						}}>
							<div>
								<C.Overall className={item.showOverall ? 'show' : ''}>
									<div>
										{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
										<p>手机扫码至移动端查看详情</p>
									</div>
								</C.Overall>
								<img src={item?.cardImage1} alt="" />
								<C.SupTip>企业精选</C.SupTip>
							</div>
							<div>
								<div className="item-title" title={item.advertisementName}>{item.advertisementName}</div>
								{item?.vendorName ? <div className="item-vendor">{item?.vendorName}</div> : null}
								<div className="item-desc">
									{item?.slogan1 ? <p>{item?.slogan1}</p> : null}
									{item?.slogan2 ? <p>{item?.slogan2}</p> : null}
									{item?.slogan3 ? <p>{item?.slogan3}</p> : null}
								</div>
								<div className="item-premium">
									<C.Premium>
										<span>{item?.minPrice?.toLocaleString()}</span><span>元起</span>
									</C.Premium>
									<DeskButton type={ButtonType.PRIMARY} css={() => `padding: 5px 20px;`}>
										查看详情
									</DeskButton>
								</div>
							</div>
						</C.Product>
					})}
				</C.ContentWrapper>
				: <C.ContentWrapper css={() => `margin-top: 20px!important;`}><span>未查询到相关内容</span></C.ContentWrapper>}
			</>}
		</DeskPageBody>;
	}
}
export default EnterpriseExclusive;